import Api from "./Api";
import ApiNode from "./ApiNode";

export default {
    fetchClients(payload) {
        return Api().post("getDataCommon.php", payload);
    },
    getFFExportBillingReport(payload) {
        return ApiNode().post("billing-report/ff-export", payload);
    },
    getTallyBillingExcelReport() {
        return ApiNode().get("billing-report/tally-billing-excel", {
            responseType: "blob",
        });
    },
};



// WEBPACK FOOTER //
// ./src/services/BillingReportService.js